
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const MobileWaitlistCTA = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="bg-gradient-to-br from-white to-grandpal-beige p-5 rounded-lg my-5 relative overflow-hidden border border-grandpal-beige-dark shadow-sm">
      <div className="relative z-10">
        <div className="flex gap-4 items-start">
          <div>
            <h3 className="text-grandpal-green text-lg font-bold mb-3 font-lora">Join a waitlist for free</h3>
            <p className="text-gray-700 text-sm mb-4 max-w-[280px]">
              Sign up to a waitlist to boost your odds of finding the right nursing home quicker.
            </p>
            <Link
              to="/waitlist"
              className="flex items-center text-white font-medium group bg-grandpal-green px-4 py-2.5 rounded-md shadow-sm hover:bg-grandpal-green-dark transition-colors"
              onClick={onClose}
            >
              Join a Waitlist
              <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          <div className="flex-none">
            <img 
              src="/lovable-uploads/b4d6b12f-537c-4411-8f7c-9770afaa4de2.png" 
              alt="Coffee and cookies" 
              className="h-24 w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileWaitlistCTA;
